import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml'
})
@Injectable()
export class sanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer:DomSanitizer) {}

  transform(v:string) : SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/sanitize-html.ts